export const addProductTemplate = 'Merchant/AddProductTemplate';
export const deleteProductTemplate = 'Merchant/DeleteProductTemplate';
export const getProductTemplates = 'Merchant/GetProductTemplates';
export const getPlansFromTemplates = 'Merchant/GetPlansFromTemplates';
